import { Link } from "react-router-dom";
import { useContext } from "react";
import { LanguageContext } from "../App";
import HotelLogo from "./HotelLogo";

const FOOTER_LINKS = [
  { key: "rooms",      path: "/camere" },
  { key: "experience", path: "/esperienza" },
  { key: "location",   path: "/posizione" },
  { key: "gallery",    path: "/galleria" },
  { key: "contacts",   path: "/contatti" },
];

export default function Footer() {
  const { t } = useContext(LanguageContext);
  const year = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#2A2726] py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 mb-10 pb-10 border-b border-[#FDFBF7]/10">
          <div className="flex flex-col gap-2">
            <Link to="/" className="hover:opacity-80 transition-opacity">
              <HotelLogo className="h-12 w-auto text-[#FDFBF7]" />
            </Link>
            <span className="font-['Manrope',sans-serif] text-xs text-[#FDFBF7]/30 tracking-[0.1em]">
              {t.footer.microcopy}
            </span>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {FOOTER_LINKS.map((link) => (
              <Link
                key={link.key}
                to={link.path}
                data-testid={`footer-nav-${link.key}`}
                className="font-['Manrope',sans-serif] text-xs uppercase tracking-[0.2em] text-[#FDFBF7]/40 hover:text-[#FDFBF7] transition-colors footer-link"
              >
                {t.nav[link.key]}
              </Link>
            ))}
          </nav>
        </div>

        {/* Legal info */}
        <div className="flex flex-col gap-1.5">
          <p className="font-['Manrope',sans-serif] text-xs text-[#FDFBF7]/20 tracking-widest">
            &copy; {year} Hotel Aurora Duino &nbsp;·&nbsp; HAD di A. Furlani sas &nbsp;·&nbsp; P.IVA 01061080329
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
            <p className="font-['Manrope',sans-serif] text-xs text-[#FDFBF7]/20 tracking-widest">
              {t.footer.rights}
            </p>
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="font-['Manrope',sans-serif] text-xs text-[#FDFBF7]/30 hover:text-[#FDFBF7]/70 transition-colors tracking-widest uppercase"
            >
              Privacy Policy
            </Link>
          </div>
        </div>

      </div>
    </footer>
  );
}
